import merge from 'lodash/merge'

// 版块结构
class SectionProps {
  /**
   * section 基础数据的配置
   * */
  static props(props) {
    let {header, list, footer} = props
    if (!header) header = {}
    if (!footer) footer = {}
    if (!list) list = []
    const prefix = 'sections/' + props.id
    // render list items
    const items = list.map((item, index) => {
      const listPrefix = `${prefix}/list/${index}`
      return {
        editable: {
          name: item.title.content,
          type: 'layout/col'
        },
        title: merge({}, item.title, {
          editable: {
            name: '列表标题',
            type: 'rich_text/h2',
            path: `${listPrefix}/title`,
          }
        }),
        media: merge({}, item.media, {
          editable: {
            name: '列表媒体',
            type: `media/${item.media ? (item.media.type || 'image') : 'image'}`,
            path: `${listPrefix}/media`,
          }
        }),
        subtitle: merge({}, item.subtitle, {
          editable: {
            name: '列表标题',
            type: 'rich_text/h3',
            path: `${listPrefix}/subtitle`,
          }
        }),
        description: merge({}, item.description, {
          editable: {
            name: '列表描述',
            type: 'rich_text/paragraph',
            path: `${listPrefix}/description`,
          }
        }),
        button: merge({}, item.button, {
          editable: {
            name: '列表按钮',
            type: 'rich_text/link',
            path: `${listPrefix}/button`,
          }
        })
      }
    })
    //
    return {
      id: props.id,
      customize: props.customize,
      title: merge({}, props.title, {
        editable: {
          name: '版块标题',
          type: 'rich_text/h2',
          path: prefix + '/title',
        }
      }),
      subtitle: merge({}, props.subtitle, {
        editable: {
          name: '版块副标题',
          type: 'rich_text/h3',
          path: prefix + '/subtitle',
        }
      }),
      media: merge({}, props.media, {
        editable: {
          name: '列表媒体',
          type: `media/${props.media ? (props.media.type || 'image') : 'image'}`,
          path: prefix + '/media',
        }
      }),
      paragraph: merge({}, props.paragraph, {
        editable: {
          name: '版块段落',
          type: 'rich_text/paragraph',
          path: prefix + '/paragraph',
        }
      }),
      button: merge({}, props.button, {
        editable: {
          name: '版块按钮',
          type: 'rich_text/button',
          path: prefix + '/button',
        }
      }),
      //
      header: {
        title: merge({}, header.title, {
          editable: {
            name: '头部标题',
            type: 'rich_text/h2',
            path: prefix + '/header/title',
          }
        }),
        subtitle: merge({}, header.subtitle, {
          editable: {
            name: '头部副标题',
            type: 'rich_text/h3',
            path: prefix + '/header/subtitle',
          }
        }),
        media: merge({}, header.media, {
          editable: {
            name: '头部媒体',
            type: `media/${header.media ? (header.media.type || 'image') : 'image'}`,
            path: prefix + '/header/media',
          }
        }),
        paragraph: merge({}, header.paragraph, {
          editable: {
            name: '头部段落',
            type: 'rich_text/paragraph',
            path: prefix + '/header/paragraph',
          }
        }),
        button: merge({}, header.button, {
          editable: {
            name: '头部按钮',
            type: 'rich_text/button',
            path: prefix + '/header/button',
          }
        })
      },
      //
      list: {
        items: items,
        is_hidden: props.is_list_hidden,
        editable: {
          name: '版块列表',
          type: 'layout/row'
        }
      },
      //
      footer: {
        paragraph: merge({}, footer.paragraph, {
          editable: {
            name: '脚部段落',
            type: 'rich_text/paragraph',
            path: prefix + '/footer/paragraph',
          }
        }),
        button: merge({}, footer.button, {
          editable: {
            name: '脚部按钮',
            type: 'rich_text/link',
            path: prefix + '/footer/button',
          }
        })
      }
    }
  }
}

export default SectionProps


// WEBPACK FOOTER //
// ./app/javascript/app/site/structures/props/section.js